// Normalizes the various shapes the backend uses for errors into
// { fieldErrors: { [fieldName]: message }, generalMessage: string }
export const parseApiError = (
  error,
  fallbackMessage = "Something went wrong. Please try again."
) => {
  const data = error?.response?.data;
  const fieldErrors = {};
  let generalMessage = fallbackMessage;

  const messages = data?.error?.message;

  if (Array.isArray(messages) && messages.length > 0) {
    messages.forEach((item) => {
      if (item?.field && item?.message) {
        fieldErrors[item.field] = item.message;
      }
    });
    // the real messages (forms also use fieldErrors to mark the fields red)
    generalMessage =
      messages
        .map((item) => item?.message)
        .filter(Boolean)
        .join("\n") || fallbackMessage;
  } else if (typeof messages === "string" && messages) {
    generalMessage = messages;
  } else if (typeof data?.message === "string" && data.message) {
    generalMessage = data.message;
  }

  return { fieldErrors, generalMessage };
};
